// src/components/filter.
import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"

//import components
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Card, CardBody, Input, FormGroup, Row, Col, Progress, Label } from "reactstrap"

import useApi from "common/ApiMiddlewere"
import { dateFormat } from "pages/Common"
import breadcrumbs from "../../../common/Breadcrumbs"
import { useLocation } from "react-router-dom"
import { toast } from "react-hot-toast"
import { Feedback_For } from "_mock/Static_data"

function FeedbacksReport() {
  const { activeInavtiveApi, postApi, getApi } = useApi()
  document.title = `Feedbacks | ${localStorage.getItem("ShopName")}`

  // useStates
  let { pathname } = useLocation()
  const [tableData, setTableData] = useState([])
  const [Loding, setLoding] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [groupType, setGroupType] = useState(1)

  const feedbackRatingReportApi = () => {
    setIsLoading(true)
    setLoding(true)
    getApi(`Report/feedback-rating-report?groupType=${groupType}`).then(({ data, status }) => {
      if (status === 200) {
        const updatedData = data.map(item => ({
          ...item,
          TotalReview: item.Average + item.Excellent + item.Good + item.Poor,
        }));
        setTableData(updatedData)
      } else {
        toast.error(data, {
          style: {
            fontSize: "15px",
          },
        })
      }
      setIsLoading(false)
      setLoding(false)
    })
  }

  useEffect(() => {
    feedbackRatingReportApi()
  }, [groupType])

  const handleSwitch = id => {
    activeInavtiveApi(`Feedback/Reviewe?id=${id}`)
  }
  const ratingsData = {
    4: 157,
    3: 97,
    2: 45,
    1: 136,
  };


  const colors = {
    4: "success",
    3: "primary",
    2: "warning",
    1: "danger",
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        {isLoading && (
          <div className="loading-overlay is-active">
            <span className="fas fa-spinner fa-3x fa-spin"></span>
          </div>
        )}
        <Breadcrumbs
          title={breadcrumbs[pathname].title}
          breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
        />
        <Card>
          <CardBody>
            <Row>
              <Col md={2}>
                <FormGroup className="mb-2">
                  <Label htmlFor="validationCustom03" className="">
                    Group Type
                  </Label>
                  <Input
                    type="select"
                    bsSize="sm"
                    id="validationCustom01"
                    className="form-control-sm"
                    name="GroupType"
                    onChange={(e) => { setGroupType(e.target.value) }}
                    value={groupType}
                  >
                    {Feedback_For?.map((item, index) => {
                      return (
                        <option key={index} className="bg-light text-dark" value={item.Value}>
                          {item.DisplayName}
                        </option>
                      )
                    })}
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            {tableData.length == 0 ?
              <Row style={{ display: "flex", justifyContent: "center" }}>
                No Record Found
              </Row>
              :
              <Row>
                {tableData.map((item, index) => {
                  const ratingsData = {
                    4: item.Excellent,
                    3: item.Good,
                    2: item.Average,
                    1: item.Poor
                  };

                  return (
                    <Col key={index} md={4} style={{ border: "1px solid #eaeaea", padding: "8px" }}>
                      <div style={{ fontSize: "16px", marginBottom: "7px" }}>
                        <strong>{item.Question}</strong>
                      </div>
                      {[4, 3, 2, 1].map((rating) => {
                        const count = ratingsData[rating] || 0;
                        const percentage = item.TotalReview ? ((count / item.TotalReview) * 100).toFixed(1) : 0;

                        return (
                          <Row key={rating} className="align-items-center mb-2">
                            <Col md={3}>
                              <div style={{ fontWeight: "500" }}>
                                {rating === 4 ? "Excellent" :
                                  rating === 3 ? "Good" :
                                    rating === 2 ? "Average" : "Poor"}
                              </div>
                            </Col>
                            <Col md={7}>
                              <Progress
                                color={colors[rating]}
                                value={percentage}
                                style={{ height: "10px", backgroundColor: "#e7e9ec" }}
                              />
                            </Col>
                            <Col md={2}>
                              <span>{count}</span>
                            </Col>
                          </Row>
                        );
                      })}
                      <Row>
                        <Col md={10} className="text-end">
                          <strong style={{ fontSize: "14px" }}>Total Reviews: </strong>
                        </Col>
                        <Col md={2} className="text-start">
                          <strong style={{ fontSize: "14px" }}>{item.TotalReview}</strong>
                        </Col>
                      </Row>
                    </Col>
                  );
                })}
              </Row>}
          </CardBody>
        </Card>
      </div>
    </div>
  )
}

FeedbacksReport.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default FeedbacksReport
